

class ProductPresetCategoryDetailViewController extends MUIViewController 
{
    static newInstance():ProductPresetCategoryDetailViewController {
        let vc = new ProductPresetCategoryDetailViewController("product-preset-category-detail-view");
        vc.initWithResource("layout/productpresets/ProductPresetCategoryDetailView.html");
        return vc;
    }

    private closeButton:MUIButton = null;
    private saveButton:MUIButton = null;    
    private nameTextField:MUITextField = null;
    private descriptionTextField:MUITextField = null;

    get preferredContentSize(){
        return new MIOSize(400, 600);
    }

    viewDidLoad(){
        super.viewDidLoad();

        this.closeButton = MUIOutlet(this, 'close-btn', 'MUIButton');
        this.closeButton.setAction(this, function(){
            this.dismissViewController(true);
        });

        this.saveButton = MUIOutlet(this, 'save-btn', 'MUIButton');
        this.saveButton.setAction(this, function(){
            DBHelper.saveMainContext();
            this.dismissViewController(true);
        });

        this.nameTextField = MUIOutlet(this, 'name-tf', 'MUITextField');
        this.nameTextField.setOnChangeText(this, function(control:MUITextField, value:string){
            this._presetCategory.name = value;
        })

        // this.descriptionTextField = MUIOutlet(this, 'description-tf', 'MUITextField');
        // this.descriptionTextField.setOnChangeText(this, function(control:MUITextField, value:string){
        //     this._presetCategory.onlineInfo = value;
        // })
    }

    viewWillAppear(animate?){
        super.viewWillAppear(animate);
        this.updateUI();
    }

    private _presetCategory:PresetCategory = null;
    set item(item:PresetCategory){
        this._presetCategory = item;
        this.updateUI();
    }

    private updateUI(){
        if (this.viewIsLoaded == false || this._presetCategory == null) return;

        this.nameTextField.text = this._presetCategory.name;
        // this.descriptionTextField.text = this._presetCategory.onlineInfo;
    }
}